export class StageRegistryStore {
    #client;
    #listeners = new Set();
    #entries = new Map();
    #started = false;
    #startGeneration = 0;
    #unsubscribe;
    constructor(client) {
        this.#client = client;
    }
    entries() {
        return [...this.#entries.values()];
    }
    entry(appName) {
        return this.#entries.get(appName);
    }
    async refresh() {
        const rows = await this.#client.query("stages.installed.v1", {});
        this.#replace(rows);
        return this.entries();
    }
    async start() {
        if (this.#started) {
            return;
        }
        const generation = ++this.#startGeneration;
        await this.refresh();
        if (generation !== this.#startGeneration) {
            return;
        }
        this.#unsubscribe = this.#client.liveQuery("stages.installed.v1", {}, (diff) => {
            this.#applyDiff(diff);
        });
        this.#started = true;
    }
    stop() {
        this.#startGeneration += 1;
        this.#unsubscribe?.();
        this.#unsubscribe = undefined;
        this.#started = false;
    }
    subscribe(listener) {
        this.#listeners.add(listener);
        return () => {
            this.#listeners.delete(listener);
        };
    }
    #applyDiff(diff) {
        for (const entry of diff.deleted) {
            this.#entries.delete(entry.appName);
        }
        for (const entry of [...diff.updated, ...diff.added]) {
            this.#entries.set(entry.appName, cloneEntry(entry));
        }
        this.#emit();
    }
    #emit() {
        const entries = this.entries();
        for (const listener of this.#listeners) {
            listener(entries);
        }
    }
    #replace(entries) {
        this.#entries.clear();
        for (const entry of entries) {
            this.#entries.set(entry.appName, cloneEntry(entry));
        }
        this.#emit();
    }
}
function cloneEntry(entry) {
    return {
        appName: entry.appName,
        assetBase: entry.assetBase,
        manifest: {
            entry: entry.manifest.entry,
            integrity: { ...entry.manifest.integrity },
            requires: [...entry.manifest.requires],
            version: entry.manifest.version,
        },
        manifestSha256: entry.manifestSha256,
        ui: {
            composes: [...entry.ui.composes],
            ...(entry.ui.icon === undefined ? {} : { icon: entry.ui.icon }),
            kind: entry.ui.kind,
            ...(entry.ui.nav === undefined ? {} : { nav: { order: entry.ui.nav.order, section: entry.ui.nav.section } }),
            title: entry.ui.title,
            uiApi: 1,
        },
    };
}
//# sourceMappingURL=stage-registry.js.map